/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Request for change status only from PENDING.
 */
export interface CryptoComDealChangeStatusRequest {
  id: number;
  status: CryptoComDealChangeStatusRequest.StatusEnum;
  /**
   * Must be NULL if status \'REJECT\'
   */
  orderId?: number;
}
export namespace CryptoComDealChangeStatusRequest {
  export const StatusEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Pending: 'PENDING',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
